/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const ScimAPI = {
  /**
   * Applies the SCIM-provisioned team, license, and role for the signed-in user.
   *
   * A SCIM-provisioned user is written straight into Keycloak by the customer's
   * IdP, so they never pass through assignGroupToUser and arrive with no license
   * record at all. This is what gives them one, and it runs on every login
   * because that is the first moment we can act on the attributes.
   */
  reconcileMe: async () =>
    (await initAxios())
      ?.post('/scim/reconcile/me')
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          status: err?.response?.status,
          result: parseErrorMsg(err),
        };
      }),

  sweepTeam: async (groupId: string, force = false) =>
    (await initAxios())
      ?.post(`/scim/sweep/${groupId}${force ? '?force=true' : ''}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

};

export default ScimAPI;
